import React, { useState, useCallback, useRef, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import TopBar, { PAGE_META } from '../components/TopBar';
import FilterRow, { DEFAULT_FILTERS } from '../components/FilterRow';
import CanvasArea from '../components/CanvasArea';
import { applyReportFilters, navigateToPage } from '../services/powerbiService';

const DashboardPage = () => {
  const reportRef = useRef(null);
  const [active, setActive]   = useState('overview');
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const handleReportReady = useCallback((report) => {
    reportRef.current = report;
    applyReportFilters(report, filters);
    // Navigate to the active page on initial load
    const pageName = PAGE_META[active]?.title;
    if (pageName) navigateToPage(report, pageName);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Re-apply filters whenever the user changes a chip
  useEffect(() => {
    applyReportFilters(reportRef.current, filters);
  }, [filters]);

  // Switch the embedded report's active page when the sidebar changes
  useEffect(() => {
    const pageName = PAGE_META[active]?.title;
    if (pageName && reportRef.current) {
      navigateToPage(reportRef.current, pageName);
    }
  }, [active]);

  return (
    <div className="app">
      <Sidebar active={active} onNav={setActive} />
      <main className="main">
        <TopBar active={active} />
        <FilterRow filters={filters} setFilters={setFilters} />
        <CanvasArea onReportReady={handleReportReady} />
      </main>
    </div>
  );
};

export default DashboardPage;
